<div *ngIf="permissionService.accessGranted$|async else test">
    <ng-content></ng-content>
</div>

<ng-template #test>
    <div class="div-no-auth" *ngIf="permissionService.initialzied$|async">
        <p>It appears your not authorized to perform any actions in the Release Info Service.</p>
    </div>
</ng-template>
